export enum IntegrationType {
  CRM = 'crm',
  NOTIFICATIONS = 'notifications',
  SIGNATURES = 'signatures',
}

export enum IntegrationOwnerType {
  ORGANIZATION = 'Organization',
  USER = 'User',
}
